import React from 'react';
import './ExcelReports.css';

const ExcelReports: React.FC = () => {
  return (
    <div className="excel-reports">
      <div className="excel-report-item">
        <div className="excel-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" fill="#217346"/>
            <path d="M14 2v6h6" fill="#217346"/>
            <path d="M8 13h8M8 17h8M8 9h8" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </div>
        <span>Отчет 1. Референтная группа Х</span>
      </div>
      
      <div className="excel-report-item">
        <div className="excel-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" fill="#217346"/>
            <path d="M14 2v6h6" fill="#217346"/>
            <path d="M8 13h8M8 17h8M8 9h8" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </div>
        <span>Отчет 2. Референтная группа Y</span>
      </div>
      
      <div className="excel-report-item">
        <div className="excel-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" fill="#217346"/>
            <path d="M14 2v6h6" fill="#217346"/>
            <path d="M8 13h8M8 17h8M8 9h8" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </div>
        <span>Отчет 3. Референтная группа Z</span>
      </div>
    </div>
  );
};

export default ExcelReports; 